module.exports = __webpack_public_path__ + "img/award.b86c919c.png";